import * as React from 'react';

import { BirthDatePicker, Checkbox, CountryDropdown, ProvinceDropdown, TextInput } from '../components/forms';
import Utils, { InputError } from '../common/utils';

interface Props {
	className?: string;
	user: UserDetails;
	currentUser: UserDetails;
	onUserChange: (e: any) => void;
	errors: {
		email: InputError,
		mailingPostalCode: InputError,
		billingPostalCode: InputError
	};
}
interface State {
	touched: {
		email: boolean;
		mailingPostalCode: boolean;
		billingPostalCode: boolean;
	};
}
class UserDetailsForm extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			touched: {
				email: false,
				mailingPostalCode: false,
				billingPostalCode: false
			}
		};
	}

	handleBlur = (field: any) => (evt: any) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true }
		});
	}

	render() {
		return (
			<div className={this.props.className}>
				<h2 className="form-fieldset-title">Contact Information</h2>
				<div className="form-fieldset">
					<div className="row">
						<TextInput
							labelText="First Name"
							name="firstName"
							onChange={this.props.onUserChange}
							value={this.props.user.firstName}
							className="col-md-6"
							required={true}
						/>
						<TextInput
							labelText="Last Name"
							name="lastName"
							onChange={this.props.onUserChange}
							value={this.props.user.lastName}
							className="col-md-6"
							required={true}
						/>
						<TextInput
							labelText="Email"
							name="email"
							onBlur={this.handleBlur('email')}
							onChange={this.props.onUserChange}
							value={this.props.user.email}
							className="col-md-6 mb-md-2"
							required={true}
							error={
								Utils.shouldMarkError(this.props.errors.email, this.state.touched.email)
									? this.props.errors.email
									: undefined
							}
						/>
						<div className="form-daypicker-responsive col-md-3">
							<BirthDatePicker
								labelText="Birthdate"
								name="birthDate"
								onChange={this.props.onUserChange}
								value={this.props.user.birthDate}
								disabled={true}
								className="mb-2"
							/>
						</div>
						<TextInput
							labelText="Sex"
							name="gender"
							value={Utils.formatFirstUpperCase(this.props.user.gender!)}
							disabled={true}
							className="col-md-3 mb-md-2"
						/>
						{this.props.currentUser.isAuthenticated &&
						this.props.currentUser.role!.some(r => r === 'Admin' || r === 'Agent' || r === 'Adjudicator') &&
							<TextInput
								labelText="Phone Number"
								name="phoneNumber"
								value={this.props.user.phoneNumber}
								className="col-md-6 mb-2"
								disabled={true}
							/>
						}
					</div>
				</div>
				<h2 className="form-fieldset-title mt-4">Mailing Address</h2>
				<div className="form-fieldset">
					<div className="row">
						<TextInput
							labelText="Address"
							name="mailingAddress"
							onChange={this.props.onUserChange}
							value={this.props.user.mailingAddress}
							className="col-md-12"
							required={true}
						/>
						<TextInput
							labelText="City"
							name="mailingCity"
							onChange={this.props.onUserChange}
							value={this.props.user.mailingCity}
							className="col-md-6"
							required={true}
						/>
						<ProvinceDropdown
							labelText="Province"
							name="mailingProvince"
							province={this.props.user.mailingProvince}
							onChange={this.props.onUserChange}
							className="col-md-6 mb-md-2"
							required={true}
						/>
						<TextInput
							labelText="Postal code"
							name="mailingPostalCode"
							onBlur={this.handleBlur('mailingPostalCode')}
							onChange={this.props.onUserChange}
							value={this.props.user.mailingPostalCode}
							className="col-sm-6 mb-md-2"
							required={true}
							error={
								Utils.shouldMarkError(this.props.errors.mailingPostalCode, this.state.touched.mailingPostalCode)
									? this.props.errors.mailingPostalCode
									: undefined
							}
						/>
						<CountryDropdown
							labelText="Country"
							name="mailingCountry"
							country={this.props.user.mailingCountry}
							onChange={this.props.onUserChange}
							className="col-md-6 mb-2"
							required={true}
						/>
					</div>
				</div>
				<h2 className="form-fieldset-title mt-4">Billing Address</h2>
				<div className="form-fieldset">
					<Checkbox
						label="Billing Address is the same as Mailing Address"
						name="isSameAddress"
						onChange={this.props.onUserChange}
						checked={this.props.user.isSameAddress}
					/>
					{!this.props.user.isSameAddress && (
						<div className="row mt-3 mt-lg-4">
							<TextInput
								labelText="Address"
								name="billingAddress"
								onChange={this.props.onUserChange}
								value={this.props.user.billingAddress}
								required={true}
								className="col-md-12"
							/>
							<TextInput
								labelText="City"
								name="billingCity"
								onChange={this.props.onUserChange}
								value={this.props.user.billingCity}
								required={true}
								className="col-md-6"
							/>
							<ProvinceDropdown
								labelText="Province"
								name="billingProvince"
								province={this.props.user.billingProvince}
								onChange={this.props.onUserChange}
								required={true}
								className="col-md-6 mb-md-2"
							/>
							<TextInput
								labelText="Postal code"
								name="billingPostalCode"
								onBlur={this.handleBlur('billingPostalCode')}
								onChange={this.props.onUserChange}
								value={this.props.user.billingPostalCode}
								required={true}
								className="col-sm-6"
								error={
									Utils.shouldMarkError(this.props.errors.billingPostalCode, this.state.touched.billingPostalCode)
										? this.props.errors.billingPostalCode
										: undefined
								}
							/>
							<CountryDropdown
								labelText="Country"
								name="billingCountry"
								country={this.props.user.billingCountry}
								onChange={this.props.onUserChange}
								required={true}
								className="col-md-6 mb-2"
							/>
						</div>
					)}
				</div>
			</div>
		);
	}
}
export default UserDetailsForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/user/UserDetailsForm.tsx